
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import $ from 'jquery'
import global from '../../../static/js/global'
import loadPage from '../../components/loadingPage'
export default {
components: {
PopupPicker,
Group,
XButton ,
XTextarea,
Cell,
Flexbox,
FlexboxItem,
PopupRadio,
Alert,
XInput,
$,
loadPage,
Confirm
},
data(){
return{
houseinfo:'',
number:'0',
show:false,
shows1:false,
shows2:false,
shows3:false,
show4:false,
show5:false,
hidds:false,
isshowBtn:true,
paytype:'0',
pricd:'',
status:'',
buyOne:'',
buyLimt:'',
buyCouts:'',
electricCout:'',
elecouts:'',
numbers:'',
paysum:'',
title:'',
housrCode:'',
successCode:'',
listCode:'',
numList:[],
allCount:'',
feeNamet:'',
waterSimplePrice:'',


comnCode:'',
hsNo:'',
hsName:'',
feeCode:'',
feeCodes:'',
feePrices:'',
feeCount:'',
billMoney:'',
realMoney:'',
mainPhone:'',
openId:'',
prompt:'',
showprompt:false,
submitable:false
}
},
mounted(){
this.elecouts = this.$router.history.current.query.elecout;
this.numbers = this.$router.history.current.query.numbers;
this.feeCodes = this.$router.history.current.query.feeCodes;
this.feePrices = this.$router.history.current.query.feePrices;


if(this.$router.history.current.path == '/pay/water'){
$(".vux-button-tab-item:last-child").addClass("vux-button-group-current").siblings(".vux-button-tab-item").removeClass("vux-button-group-current")

document.title = "水费缴纳";
}


let index = "";
let selfs = this;
$(".btnm").click(function(){
index = $(this).index();
$(this).addClass("btnActive")
$(this).parent(".vux-flexbox-item").siblings(".vux-flexbox-item").find(".btnm").removeClass("btnActive");
selfs.number = parseInt($(this).find("strong").text());


if(selfs.status == false){
if(selfs.number > parseInt(selfs.buyLimt)){
selfs.show = true;
selfs.shows1 = false;
selfs.electricCout = selfs.number * selfs.pricd;
}
}else if(selfs.status == true){
if(selfs.number > parseInt(selfs.buyOne)){
selfs.shows1 = true;
selfs.show = false;
selfs.electricCout = selfs.number * selfs.pricd;
}
}
})


$(".kystr .weui-input").on("change",function(){
if(isNaN(selfs.number)){
selfs.prompt='请输入有效内容！';
selfs.showprompt= true;
selfs.number = 0;
}else{
if (selfs.status == false) {
if (selfs.number > parseInt(selfs.buyLimt)) {
console.log("****************")
console.log(selfs.number)
selfs.show = true;
selfs.shows1 = false;
selfs.electricCout = selfs.number * selfs.pricd;
} else {
selfs.show = false;
selfs.shows1 = false;
selfs.electricCout = selfs.number * selfs.pricd;
}
} else if (selfs.status == true) {
if (selfs.number > parseInt(selfs.buyOne)) {
selfs.shows1 = true;
selfs.show = false;
selfs.electricCout = selfs.number * selfs.pricd;
} else {
selfs.shows1 = false;
selfs.show = false;
selfs.electricCout = selfs.number * selfs.pricd;
}
}
}
})
$("#no1").click(function(){
selfs.number = selfs.buyLimt;
})
$("#no2").click(function(){
selfs.number = selfs.buyOne;
})



$("#submitForm .weui-dialog__btn_primary").click(function(){

let mInfo = new Object();
mInfo.comnCode = selfs.comnCode;
mInfo.openid = selfs.$router.history.current.query.openid;;
mInfo.memberNo = selfs.$router.history.current.query.phone;
mInfo.tradeAmount = selfs.allCount;
mInfo.tradeDesc = selfs.feeNamet;
mInfo.tradeName = selfs.feeNamet;
mInfo.tradeNo = selfs.listCode;
let url = global.host + 'hydro/getpayurl'
selfs.$http.post(url,mInfo).then(function(res){

window.location.href = res.body.payurl;
},function(err){
console.log(err)
})

})
},
methods:{
/*根据不同的操作进行操作*/
refresh(){
if(this.prompt == '您有未处理的订单,请优先处理'){
this.submitable = true;
this.$router.push({path:'/paymentRecord',query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone}})
}else{
this.submitable = false;
}
},
/*提交订单之前的操作*/
submitBefore(){
this.submitable = true
this.$http.get(global.host + 'hydro/findownerunpaidorder?comnCode=' + this.comnCode + '&houseNo=' + this.hsNo + '&openid=' + this.$router.history.current.query.openid + '&phoneNo=' + this.$router.history.current.query.phone).then(function (res) {
console.log("%%%%%%%%%%%%%%%%%%%%%")
console.log(res)
if(res.body.code == '110'){
this.submitable = false;
this.submit();
}else if(res.body.code == '120'){
this.prompt = '您有未处理的订单,请优先处理'
this.showprompt = true
}
},function (err) {
console.log(err)
})
/*提交订单信息*/
},submit() {
let selfs = this;
if(selfs.buyCouts <= 0){
selfs.shows2 = true;
}else{
if(selfs.number == 0){
selfs.shows3 = true;
}else{

/***************提交订单ajax*****************/

let uns = new Object();
uns.comnCode = selfs.$router.history.current.query.comnCodes;
uns.hsNo =   selfs.$router.history.current.query.hsNos;
uns.hsName = selfs.$router.history.current.query.hsNames;
uns.feeCount = selfs.numbers;
uns.billMoney = selfs.elecouts;
uns.realMoney = selfs.elecouts;
uns.feeCode = selfs.feeCodes;
uns.feePrice = selfs.feePrices;
uns.mainPhone = selfs.$router.history.current.query.phone
uns.openId = selfs.$router.history.current.query.openid;


let usino = new Object();
usino.comnCode = selfs.comnCode;
usino.hsNo =   selfs.hsNo;
usino.hsName = selfs.hsName;
usino.feeCount =  selfs.number;
usino.billMoney = selfs.electricCout;
usino.realMoney = selfs.electricCout;
usino.feeCode = selfs.feeCode;
usino.feePrice = selfs.pricd;
usino.mainPhone = selfs.$router.history.current.query.phone
usino.openId = selfs.$router.history.current.query.openid;
let datms = {
"list":[usino,uns]
}
if(selfs.numbers == undefined||selfs.numbers == 0){
datms.list.pop();
}

let url = global.host + 'hydro/subwaterelec'
selfs.$http.post(url,datms).then(function(res){
selfs.successCode = res.body.code;
selfs.listCode = res.body.tradeNo;
if(selfs.successCode == "110"){
let url = global.host + 'hydro/findunpaiddetail?tradeNo=' + selfs.listCode
selfs.$http.get(url).then(function(res){
selfs.allCount = res.body.account;

let dalList = res.body.result;
selfs.numList = new Object();
for(let mk in dalList){
if(dalList[mk].feeCount==0){continue;}
selfs.numList[mk] = dalList[mk];
selfs.feeNamet = dalList[mk].feeName
}
},function(err){
console.log(err)
})
}else if(selfs.successCode == "120"){
selfs.show5 = true;
}

},function(err){
console.log(err)
})
selfs.show4 = true;
}
}

}
},
beforeMount(){
this.show_1 = true;
let url = global.host + 'hydro/findhouseinfo?openid=' + this.$router.history.current.query.openid + "&phone=" + this.$router.history.current.query.phone + "&paytype=" + this.paytype
this.$http.get(url).then(function(res){

this.show_1 = false;
this.houseinfo = res.body.comnName + " " + res.body.houseCode;
this.dataList = new Object();
let dats = res.body.typeprice;
let dats1 = res.body.limitlist;
this.pricd = dats.feePrice;
this.status = res.body.paystatus;
this.buyOne = dats1[0].buyOnce;
this.buyLimt = dats1[0].buyLimit;
this.buyCouts = res.body.buycount;

this.comnCode = dats1[0].comnCode;
this.hsNo = res.body.houseCode;
this.hsName = res.body.hsName;
this.feeCode = dats.feeCode;
this.feePrice = dats.feePrice;
this.feeCount = dats.feeCount;
this.billMoney = dats.billMoney;
this.realMoney = dats.realMoney;
this.mainPhone = dats.mainPhone;


},function(err){
console.log(err)
})
}
}



// WEBPACK FOOTER //
// ./src/components/payComponents/water.vue